var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23832 2.04445C3.65196 1.1818 1.75 2.31957 1.75 4.03299L1.75 17.9672C1.75 19.6806 3.65196 20.8184 5.23832 19.9557L18.0503 12.9886C19.6499 12.1188 19.6499 9.88144 18.0503 9.01155L5.23832 2.04445ZM0.250001 4.03299C0.250001 1.12798 3.41674 -0.653562 5.95491 0.726689L18.7669 7.6938C21.411 9.13169 21.411 12.8685 18.7669 14.3064L5.95491 21.2735C3.41674 22.6537 0.25 20.8722 0.25 17.9672L0.250001 4.03299Z",
    fill: "currentColor",
    fillOpacity: 0.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.0867874b5ce090dcb3ebce120c01274b.svg";
export { ForwardRef as ReactComponent };